<!-- sort by -->
<button class="w-12 p2 col-11 center sort-label cursor-pointer"
        type="button"
        [dialogOpen]="dialogId">
    {{'Sort by:' | translate}}&nbsp;{{selectedLabel}}
</button>

<!-- dialog content -->
<dialog class="listing-sort-modal"
        [id]="dialogId"
        [side]="'right'"
        [blockScroll]="true"
        #dialog>
    <div
         class="pos-relative flex-column flex-justify-between overflow-hidden bg-col-w height-100-vh modal-right-container-inner">
        <div
             class="w-12 pos-absolute top-0 modal-right-container-inner-icon b-b b-col-4 p-r-3 p-l-3 p-r-0-m p-r-0-s p-l-4-m p-l-4-s flex flex-justify-between">
            <span class="h3">{{'Sort by' | translate}}</span>

            <!-- close -->
            <button class="p-a-4-m p-a-4-s"
                    type="button"
                    [attr.aria-label]="'Close filters' | translate"
                    (click)="closeModal()">
                <i class="icon-close fs-4 fs-3-s"
                   aria-hidden="true"></i>
            </button>
        </div>
        <div class="flex-column">
            @for (option of sort.getOptions(); track $index) {
            <button class="w-12 p1 col-12 left b-col-4 p-l-3 p-t-5 p-b-3 cursor-pointer sort-option"
                    [class.b-t]="!$first"
                    [class]="{'b-b': $last, 'bg-col-33': selectedLabel === option.label}"
                    type="button"
                    (click)="handleSortBy(option)">
                {{option.label}}
            </button>
            }
        </div>
    </div>
</dialog>
<overlay class="z-10"
         [visible]="dialog.isVisible$"
         (click)="dialog.close()" />